import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";

import Preloader from "../../views/Preloader/Preloader";
import AcceptInscripcion from './AcceptInscripcion';

import { ValidateInscrip, EstPendientes, EstPendientesFilter } from '../../funciones/HeaderFunction';


class InscripcionesPendientes extends Component {
    state = {
        cantNotifValidateInscrip: "",
        estPendientes: [],
        searchEst: "",
        preloader: "",
    }

    constructor (props) {
        super (props);

        ValidateInscrip  ((resp) => {
            this.setState(resp)
        })

        EstPendientes  ((resp) => {
            this.setState({
                estPendientes: resp
            })
        })

    }

    updDatos = () => {
        ValidateInscrip  ((resp) => {
            this.setState(resp)
        })

        EstPendientes  ((resp) => {
            this.setState({
                estPendientes: resp
            })
        })
    }

    buscaEnter = () => (e) => {
        if (e.which === 13){
            this.filterEst()
        };
    }

    filterEst = () => {
        this.setState({
            preloader: {
                icon:"fa fa-spinner fa-spin",
                text: "Buscando, espera por favor"
            }
        }, () => {
            EstPendientesFilter  (this.state.searchEst, (resp) => {
                this.setState({
                    estPendientes: resp,
                    preloader: "",
                    searchEst: ""
                })
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase(),
        });
    };

    contenido = () => {
        let { estPendientes, searchEst, preloader } = this.state;

        if (estPendientes.length === 0) return (
            <React.Fragment>
                <div style={{padding:10}}>
                    <span className="text-danger">Buscar un estudiante específico</span>
                    <input type="text" onKeyPress={this.buscaEnter()} value = {searchEst} onChange={this.cambiaValor("searchEst")} className="form-control" placeholder="Ingresa la cédula o el nombre del estudiante"/>
                </div>
                <div style={{padding:10}} align="center" className="text-danger">Ninguna Solicitud disponible</div>
            </React.Fragment>
        )

        return (
            <React.Fragment>
                <div style={{padding:10}}>
                    <span className="text-danger">Buscar un estudiante específico</span>
                    <input type="text" onKeyPress={this.buscaEnter()} value = {searchEst} onChange={this.cambiaValor("searchEst")} className="form-control" placeholder="Ingresa la cédula o el nombre del estudiante"/>
                </div>
                <div style={{padding:10}} align="center" className="text-primary"><i className={preloader.icon}></i> {preloader.text}</div>
                {estPendientes.map(option => (
                    <AcceptInscripcion 
                        key ={option[0].id_estudiante}
                        est={option[0].id_estudiante}
                        isOpen={false}
                        funcion = {this.updDatos}
                    />
                ))}
            </React.Fragment>
        )
    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12} align="justify">
                        En esta sección podrás ver y aprobar (o no) todas los estudiantes que aspiran a la inscripción, para ello debes realizar los siguientes pasos:
                    </Col>

                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>Una vez selecciones el estudiante haz click sobre el nombre y se desplegará la información sobre las materias inscritas</div>
                    </Col>

                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>Verifica toda la información ingresada por el estudiante y selecciona uno de los siguiente botones:</div>
                    </Col>
                    <Col md={2} align="center" className="custom-mt-10">
                        <button style={{borderWidth: 1}} className="btn btn-primary btn-sm"><i className="fa fa-check"></i></button>
                    </Col>
                    <Col md={10} align="justify" className="custom-mt-10">
                        <div>Este botón permite <strong>Aprobar</strong> la inscripción del estudiante. Aparecerá en los listados de las secciones inscritas (aquellas que inscribió en la modalidad presencial)</div>
                    </Col>
                    <Col md={2} align="center" className="custom-mt-10">
                        <button style={{borderWidth: 1}} className="btn btn-danger btn-sm"><i className="fa fa-times"></i></button>
                    </Col>
                    <Col md={10} align="justify" className="custom-mt-10">
                        <div>Este botón permite <strong>No Aprobar</strong> la inscripción del estudiante. El estudiante no estará inscrito en ninguna de las secciones seleccionadas</div>
                    </Col>

                    <Col md={12} align="justify" className="custom-mt-10">
                        <div><strong style={{color:"#1f2f6e"}}>Tip:</strong> Puedes <span className="text-danger">Buscar un estudiante específico</span> en el <strong>Cuadro de Texto</strong> de la parte superior de este módulo ingresando su cédula de identidad, su nombre o su apellido.</div>
                        <div className="custom-mt-10">Esta opción mostrará las coincidencias respecto a la búsqueda seleccionada</div>
                    </Col>
                </Row>  
            </React.Fragment>
        )
    }

    render() {
        if (this.state.cantNotifValidateInscrip === "") {
            return(<Preloader/>) 
        }else if (this.state.cantNotifValidateInscrip === 0) {
            return (<Redirect to="/noticias" />)
        }else if (this.state.cantNotifValidateInscrip > 0) { 
            return (
                <React.Fragment>
                    <div className="content">
                        <Grid fluid>
                            <Row>
                                <Col md={8}>
                                    <div className="custom-alert-info" style={{marginBottom:15}}>
                                        <div className="title" style={{fontSize:18}}>
                                            Inscripciones por Aprobar
                                            <p style={{color:"#000", fontSize:10}}>{`Tienes (${this.state.cantNotifValidateInscrip}) inscripciones pendientes`}</p>
                                        </div>
                                    </div>
                                    <div style={{backgroundColor:"#FFF", padding: 5}}>
                                        { this.contenido() }
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <CustomCard
                                        styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                        title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                        category={<span style={{color: "#fff"}}>Aprobar Inscripciones</span>}
                                        color="#a80012"
                                        content={this.ayuda()}
                                    />
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </React.Fragment>
            );
        }
    }
}
 
export default InscripcionesPendientes;


// WEBPACK FOOTER //
// ./src/views/Inscripcion/InscripcionesPendientes.jsx